import React, { useState } from 'react';
import { DPage, DPageBody } from '../../../../dum';
import { OrderQuotationsListBlock } from './blocks/order-quotations-list-block';
import { PrintableQuotation } from './blocks/printable-quotation';
import { OrderQuotationsPageQuery } from '../../../../../services';

export type TOrderQuotation =
    | OrderQuotationsPageQuery['paginatedOrderQuotations']['docs'][number]
    | null;

interface IQuotationPrintRequest {
    orderQuotation: TOrderQuotation;
    requestId: number;
}

export function OrderQuotationsPage() {
    // A request number is kept separately from the selected row so clicking the
    // same export action twice still creates a new print job.
    const [printRequest, setPrintRequest] = useState<IQuotationPrintRequest>({
        orderQuotation: null,
        requestId: 0,
    });

    const requestPrint = (orderQuotation: NonNullable<TOrderQuotation>) => {
        setPrintRequest((current) => ({
            orderQuotation,
            requestId: current.requestId + 1,
        }));
    };

    return (
        <DPage>
            <DPageBody disableGutters>
                <OrderQuotationsListBlock requestPrint={requestPrint} />
                <PrintableQuotation
                    orderQuotation={printRequest.orderQuotation}
                    printRequestId={printRequest.requestId}
                />
            </DPageBody>
        </DPage>
    );
}
